module.exports = "pegasus/assets/blocks/column-16-basic.png";